/**
 * Partner blog posts for TabTrips Extranet (hardcoded — no CMS).
 * Add an entry here and create a page under src/pages/blog/<slug>.jsx
 */

export const BLOG_HERO_IMAGE =
  "https://tabtrips.com/images/imgoffer.png";

export const BLOG_POSTS = [
  {
    slug: "zero-percent-commission-offer",
    title: "Earn Unlimited with TabTrips — 0% Commission Offer",
    excerpt:
      "Limited-time offer: zero platform commission for the first 30 days on every new property you list on TabTrips Extranet.",
    date: "May 2026",
    readTime: "5 min read",
    tag: "Partners",
    image: BLOG_HERO_IMAGE,
    cardGradient: "from-orange-500 via-amber-500 to-orange-600",
  },
];

export function getBlogPostBySlug(slug) {
  return BLOG_POSTS.find((p) => p.slug === slug) ?? null;
}
